import React from 'react';
import FormnavBar from '../../../components/common/wizard_navbar'
import WizardLeft from '../../../components/common/wizard_left'
import services from '../../../services';
import $ from 'jquery';

import { toast } from 'react-toastify';
import { Row } from 'antd';
import IVVFrom from './IVVFrom';


const queryString = require('query-string');

const parcel = []

let combolistrequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

class InstalaçõesInsert extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            headName: null,
            params: {},
        }
    }


    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        let headName = "Gerir Instalações";

        this.setState({
            headName,
            params: parsed
        });
    }

    // getAllLIst = () => {
     
    // }

    // /* Api chamando dados da tabela */

    // getlist = async (listname) => {
    //     let res = await services.apiCall.requestApi("allservice/" + listname, combolistrequest, 'post');
    //     if (res) {
    //         let all_list = { ...this.state.all_list }
    //         all_list[listname] = res
    //         this.setState({
    //             all_list
    //         })
    //     }
    // }

   


    // /*  Para fechar pop-up  */
    // closePopup = () => {
    //     $(".left-popup").trigger('click');
    //     this.updatesel_nev(this.state.sel_nev);
    // }

    // scrolthis = (sel_nev) => {
    //     if ($('#' + sel_nev).length)
    //         $('html, body').animate({
    //             scrollTop: $('#' + sel_nev).offset().top - 95 //#DIV_ID is an example. Use the id of your destination on the page
    //         }, 'slow');
    // }

    // handleSubmit = async (e, backUrl) => {
      
    // }

    // /* Deletar linha da tabela de dados */

    // handleDelete = (status) => {
    //     //console.log("status", status)
    // }

    /*  Para renderizar o conteúdo html da página   */

    render() {

        return (
            <div className="dashboard">
                <FormnavBar 
                    to="/instalacaovinica" 
                    type="instalacoesvinicas" 
                    headName={this.state.headName} 
                    hideButton={ true } 
                />
                <div className="full-container edit-ward">
                    <IVVFrom to="/instalacaovinica"/>
                </div>
            </div>
        )
    }
}

export default InstalaçõesInsert;